import React, { useState, useEffect } from "react";
import UserPanel from "@/Components/PageTop/UserPanel";
import HomeLogo from "@/assets/loginLogo.svg";
import { getQueryString, rebuildFormula, replaceFormulaStr } from "@/config/func";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ModelViewer from "@/Components/3DViewer";
import { props_T, phaseState, K0 } from "@/config/const";
import {
  get_properties_from_cas,
  get_T_dep_properties_from_cas,
  get_Liquid_Thermal_Conductivity_Sensitivity,
  get_Gas_Thermal_Conductivity_Sensitivity,
  get_Ideal_Gas_Heat_Capacity_Sensitivity,
  get_Solid_Heat_Capacity_Sensitivity,
  get_Heat_of_Vaporization_Sensitivity,
  get_Molar_Liquid_Density_Sensitivity,
  get_Molar_Solid_Density_Sensitivity,
  get_Liquid_Viscosity_Sensitivity,
  get_Gas_Viscosity_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity,
  get_Surface_Tension_Sensitivity,
  get_Solubility_in_Water_Sensitivity,
  get_Liquid_Heat_Capacity_Sensitivity,
  getPropsNames,
  getMaterials,
} from "@/services/propsApi";
import { Col, Input, Row, Space } from "antd";
import S_charts from "./S_charts";
import QueryBar from '@/Components/QueryBar'

const specials: any = [
  "KLDIP",
  "KVDIP",
  "CPIGDP",
  "CPSDIP",
  "DHVLDP",
  "DNLDIP",
  "DNSDIP",
  "MULDIP",
  "MUVDIP",
  "PLXANT",
  "PSXANT",
  "SIGDIP",
  "VLBROC",
  "WATSOL",
  // "VLSTD",
];

const funcList: any = {
  get_Liquid_Thermal_Conductivity_Sensitivity,
  get_Gas_Thermal_Conductivity_Sensitivity,
  get_Ideal_Gas_Heat_Capacity_Sensitivity,
  get_Solid_Heat_Capacity_Sensitivity,
  get_Heat_of_Vaporization_Sensitivity,
  get_Molar_Liquid_Density_Sensitivity,
  get_Molar_Solid_Density_Sensitivity,
  get_Liquid_Viscosity_Sensitivity,
  get_Gas_Viscosity_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Liquid_Sensitivity,
  get_Saturation_Vapor_Pressure_Gas_Solid_Sensitivity,
  get_Surface_Tension_Sensitivity,
  get_Solubility_in_Water_Sensitivity,
  get_Liquid_Heat_Capacity_Sensitivity,
};

const Component = (props: any) => {
  const { cas } = useParams();
  // const location = useLocation();

  // console.log('casssssssss',location);

  const [source, setSource] = useState<any>(null);
  const history = useNavigate();
  const [query, setQuery] = useState<any>(null);
  const [curParam, setCurParam] = useState<any>(null);
  const [propNameList, setPropNameList] = useState<any>(null);
  const [dataSource, setDataSource] = useState<any>(null);
  const [dataSource_T, setDataSource_T] = useState<any>(null);
  const [T, setT] = useState<any>(25);

  const [T_range, setT_range] = useState<any>([25, 200]); //温度范围

  const [isSettingT, setIsSettingT] = useState<any>(false);

  const [T_step, setT_step] = useState<any>(1); //温度范围步长
  const [curType, setCurType] = useState<any>(null); //当前类型
  const [s_data, setS_data] = useState<any>(null); //敏感度数据
  const [mgd_data, setMgd_data] = useState<any>(null); //敏感度条目

  // const [curItem,setCurItem]=useState<any>(null);

  console.log("s_data", s_data);

  // const getMaterial = (key: any) => {
  //   if (key) {
  //     const item: any = materials.find(
  //       (m: any) =>
  //         m.cname === key ||
  //         m.cas_code === key ||
  //         m.name === key ||
  //         m.component === key ||
  //         m.alias === key
  //     );
  //     return item;
  //   } else {
  //     return null;
  //   }
  // };

  useEffect(() => {
    getPropsNames().then((res: any) => {
      setPropNameList(res.data.response.data);
    });
  }, []);

  // console.log("propNameList", propNameList);

  useEffect(() => {
    // const k = getQueryString("key") ? getQueryString("key") : "氢气";
    // setQuery(k);
    // const i: any = getMaterial(k);
    // // console.log("kkkkk", k);
    // // console.log("iiii", i);
    // setSource(i);

    if (cas) {
      // getMaterials({ cas }).then((r:any) => {
      //   console.log(r);
      //   // setQuery(r.response.data[0].Name_ZH);
      // });

      get_properties_from_cas(cas).then((res: any) => {
        setDataSource(res.data.data);
      });
      get_T_dep_properties_from_cas(cas, T).then((res: any) => {
        const d: any = res.data.data;
        const keys: any = Object.keys(d);
        const showP: any = [];
        for (let n = 0; n < keys.length; n++) {
          if (d[keys[n]]) {
            showP.push(keys[n]);
            // break;
          }
        }
        setCurType(showP[0]);
        setMgd_data(showP);
        setDataSource_T(res.data.data);
      });
    }
  }, [cas, T]);

  useEffect(() => {
    if (dataSource && curType) {
      funcList[`get_${curType}_Sensitivity`](dataSource.CAS, T_range[0], T_range[1], T_step).then(
        (r: any) => {
          setS_data(r.data.data);
        }
      );
    }
  }, [curType, T_step, T_range]);

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      history(`/info?key=${query}`);
      window.location.reload();
    }
  };

  const getparams = () => {
    if (source) {
      const { properties } = source;
      return (
        <ul className="paramsList">
          {propNameList.map((item: any, index: any) => {
            return (
              <li
                key={index}
                onClick={() => setCurParam(item.code)}
                className={curParam === item.code ? "active" : ""}
              >
                <span>{curParam === item.code ? "●" : "○"}</span>
                {item.alias}-{item.code} : {item.Unit}
                {/* ({key}) {item.units} */}
              </li>
            );
          })}
        </ul>
      );
    } else {
      return null;
    }
  };

  const getItenGrid = (key: string) => {
    return (
      <div className={`gridItem${curParam === key ? " active" : ""}`}>
        <div className="gridItemName">{paramInfo(key)?.alias}：</div>
        <div className="gridItemValue">{getValue(key)}</div>
        {paramInfo(key) ? (
          dataSource ? (
            dataSource[key] ? (
              <div className="gridItemUnit">{paramInfo(key).Unit}</div>
            ) : (
              ""
            )
          ) : (
            ""
          )
        ) : (
          ""
        )}
      </div>
    );
  };

  // const getItem = (key: any) => {
  //   const item: any = params.find((i: any) => i.title === key);
  //   return item;
  // };

  const getValue = (key: string) => {
    // {dataSource ? (dataSource[key] ? dataSource[key] : " - ") : " - "}
    if (dataSource) {
      if (dataSource[key]) {
        if (key === "PHASE_STP") {
          return (
            <Space>
              <span>
                <img src={phaseState[dataSource[key]].icon} style={{ width: "30px" }} />
              </span>
              <span>{phaseState[dataSource[key]].desc}</span>
            </Space>
          );
        } else {
          return dataSource[key];
        }
      } else {
        return " - ";
      }
    } else {
      return " - ";
    }
  };

  console.log(T_range);

  const paramInfo = (key: string) => {
    if (propNameList) {
      const item: any = propNameList.find((i: any) => i.code === key);
      return item;
    }
  };

  const disUnit = (key: string) => {
    if (dataSource) {
      if (dataSource[key]) {
        const item = paramInfo(key);
        if (item) {
          return <div className="itemUnit">{item.Unit}</div>;
        } else {
          return "";
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const changeTRange = (e: any) => {
    const lt: any = document.getElementById("lt");
    const ht: any = document.getElementById("ht");
    if (e.key === "Enter") {
      setT_range([Number(lt.value), Number(ht.value)]);
    }
  };

  const changeT = () => {
    const i: any = document.getElementById("Tinput");
    setT(Number(i.value));
    setIsSettingT(false);
    i.blur();
  };

  //绑定快捷键提交更新flow name
  const keySubUpdateT = (e: any) => {
    if (e.key === "Enter") {
      changeT();
    }
    if (e.key === "Escape") {
      setIsSettingT(false);
    }
  };

  console.log('dataSource',dataSource);
  return (
    <div className="mainPage">
      <div className="pTop2">
        {/* <div></div> */}
        <div className="homeLg">
          <img
            src={HomeLogo}
            alt=""
            style={{ cursor: "pointer", height: "23px", marginRight: "2rem" }}
            onClick={() => history("/")}
          />
          <QueryBar initValue={dataSource?.Name_ZH} />
        </div>
        <UserPanel />
      </div>
      {dataSource ? (
        <div className="mainContent">
          <div className="pageMainContent">
            <div className="p_left" style={{ paddingRight: "1rem" }}>
              <Row gutter={20}>
                <Col span={9}>
                  <ModelViewer
                    filePath={`${dataSource.sdf}`}
                    height="300px"
                    width="100%"
                    // disLenged={true}
                    bgColor="rgba(2, 77, 196,0.03)"
                    pngImg={`${dataSource.svg}`}
                    // refresh={false}
                  />
                </Col>
                <Col span={8}>
                  <ul className="itemList">
                    <li>
                      <div className="itemName">中文名称：</div>
                      <div className="itemValue">{dataSource?.Name_ZH}</div>
                    </li>
                    <li>
                      <div className="itemName">英文名称：</div>
                      <div className="itemValue">{dataSource?.Name_EN}</div>
                    </li>
                    <li>
                      <div className="itemName">物质分类：</div>
                      <div className="itemValue">{dataSource?.TYPE}</div>
                    </li>
                    <li>
                      <div className="itemName">分子式：</div>
                      <div className="itemValue">
                        {dataSource ? rebuildFormula(dataSource.Molecular_formula) : ""}
                      </div>
                    </li>
                    <li>
                      <div className="itemName">CAS号：</div>
                      <div className="itemValue">{dataSource?.CAS}</div>
                    </li>
                    <li className={`${curParam === "MW" ? " active" : ""}`}>
                      <div className="itemName">分子量：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.MW ? dataSource.MW : " - ") : " - "}
                      </div>
                    </li>
                    <li className={`${curParam === "CHARGE" ? " active" : ""}`}>
                      <div className="itemName">电荷数：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.CHARGE ? dataSource.CHARGE : " - ") : " - "}
                      </div>
                    </li>
                  </ul>
                </Col>
                <Col span={7}>
                  <ul className="itemList">
                    <li className={`${curParam === "TB" ? " active" : ""}`}>
                      <div className="itemName">常压沸点：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.TB ? dataSource.TB : " - ") : " - "}
                      </div>
                      {disUnit("TB")}
                    </li>
                    <li className={`${curParam === "FREEZEPT" ? " active" : ""}`}>
                      <div className="itemName">凝固点：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.FREEZEPT ? dataSource.FREEZEPT : " - ") : " - "}
                      </div>
                      {disUnit("FREEZEPT")}
                    </li>
                    <li className={`${curParam === "TC" ? " active" : ""}`}>
                      <div className="itemName">临界温度：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.TC ? dataSource.TC : " - ") : " - "}
                      </div>
                      {disUnit("TC")}
                    </li>
                    <li className={`${curParam === "PC" ? " active" : ""}`}>
                      <div className="itemName">临界压力：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.PC ? dataSource.PC : " - ") : " - "}
                      </div>
                      {disUnit("PC")}
                    </li>
                    <li className={`${curParam === "rhoc" ? " active" : ""}`}>
                      <div className="itemName">临界密度：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.rhoc ? dataSource.rhoc : " - ") : " - "}
                      </div>
                      {disUnit("rhoc")}
                    </li>
                    <li className={`${curParam === "VC" ? " active" : ""}`}>
                      <div className="itemName">临界体积：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.VC ? dataSource.VC : " - ") : " - "}
                      </div>
                      {disUnit("VC")}
                    </li>
                    <li className={`${curParam === "ZC" ? " active" : ""}`}>
                      <div className="itemName">临界压缩因子：</div>
                      <div className="itemValueNum">
                        {dataSource ? (dataSource.ZC ? dataSource.ZC : " - ") : " - "}
                      </div>
                      {disUnit("ZC")}
                    </li>
                  </ul>
                </Col>
              </Row>
              <Row gutter={20} className="mt2">
                <Col span={9}>
                  <div className="l_line_2">
                    <Row>
                      <Col span={24}>
                        {getItenGrid("PHASE_STP")}
                        {getItenGrid("TPT")}
                        {getItenGrid("Pt")}
                        {getItenGrid("Hsub_Tt")}
                        {getItenGrid("DHVLB")}
                        {getItenGrid("HFUS")}
                        {getItenGrid("Hfus_Tm")}
                        {/* {getItenGrid("SRKOMG")} */}
                        {getItenGrid("SRKTC")}
                        {getItenGrid("SG")}
                        {getItenGrid("SRKPC")}
                        {getItenGrid("API")}
                        {getItenGrid("S025E")}
                        {getItenGrid("VLSTD")}
                        {getItenGrid("rhol_60F")}
                        {getItenGrid("MUP")}
                        {getItenGrid("VB")}
                        {getItenGrid("OMEGA")}
                        {/* {getItenGrid("rhog_STP")}
                        {getItenGrid("rhol_STP")}
                        {getItenGrid("Vmg_STP")}
                        {getItenGrid("Vml_STP")}
                        {getItenGrid("Hf_STP")}
                        {getItenGrid("Hvap_298")} */}
                        {/* {getItenGrid("Gfg")}
                        {getItenGrid("Hfg")}
                        {getItenGrid("S0gs")} */}
                        {getItenGrid("HCOM")}
                        {getItenGrid("DGFORM")}
                        {getItenGrid("DGSFRM")}
                        {getItenGrid("DHAQFM")}
                        {getItenGrid("DHSFRM")}
                        {getItenGrid("DHFORM")}
                        {getItenGrid("DCPLS")}
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col span={15}>
                  <div className="propBlock">
                    <Space>
                      <div className="t3">温度相关的物性：</div>
                      <Space>
                        <div style={{ marginLeft: "2rem" }}>当前温度：</div>
                        <Input
                          type="text"
                          defaultValue={T}
                          style={{
                            width: "10rem",
                            fontWeight: "bold",
                            fontSize: "1.6rem",
                            padding: "0 1rem",
                          }}
                          id="Tinput"
                          onKeyUp={keySubUpdateT}
                          suffix={<span className="fieldUnit">°C</span>}
                        />
                      </Space>
                    </Space>

                    <ul className="ptShow mt1">
                      {dataSource_T
                        ? Object.keys(dataSource_T).map((key: any, index: any) => {
                            return (
                              <li key={index}>
                                <div className="pt_name">{props_T[key]?.name}</div>
                                <div className="pt_value">
                                  {dataSource_T[key] ? dataSource_T[key] : "-"}
                                </div>
                                {dataSource_T[key] ? (
                                  <div className="pt_unit">{props_T[key]?.unit}</div>
                                ) : (
                                  ""
                                )}
                              </li>
                            );
                          })
                        : ""}
                    </ul>
                  </div>

                  <div className="propBlock mt2">
                    <Space>
                      <div className="t3">
                        {dataSource?.Name_ZH}{" "}
                        {dataSource ? rebuildFormula(dataSource.Molecular_formula) : ""}{" "}
                        温度灵敏度计算：
                      </div>
                      <Space>
                        <div>当前温度范围：</div>
                        <Space>
                          <Input
                            type="text"
                            id="lt"
                            onKeyUp={changeTRange}
                            defaultValue={T_range[0]}
                            style={{
                              width: "10rem",
                              fontWeight: "bold",
                              fontSize: "1.6rem",
                              padding: "0 1rem",
                            }}
                            suffix={<span className="fieldUnit">°C</span>}
                          />
                          ~
                          <Input
                            type="text"
                            id="ht"
                            onKeyUp={changeTRange}
                            defaultValue={T_range[1]}
                            style={{
                              width: "10rem",
                              fontWeight: "bold",
                              fontSize: "1.6rem",
                              padding: "0 1rem",
                            }}
                            suffix={<span className="fieldUnit">°C</span>}
                          />
                        </Space>
                      </Space>
                    </Space>
                    <Row>
                      <Col span={4}>
                        <ul className="propTypeList">
                          {mgd_data
                            ? mgd_data.map((item: any) => {
                                return (
                                  <li
                                    className={curType === item ? "active" : ""}
                                    onClick={() => setCurType(item)}
                                    key={item}
                                  >
                                    {props_T[item]?.name}
                                  </li>
                                );
                              })
                            : ""}
                        </ul>
                      </Col>
                      <Col span={20}>
                        {s_data ? (
                          <S_charts
                            title={props_T[curType].name}
                            unit={props_T[curType].unit}
                            source={s_data}
                          />
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
            {/* <div className="p_right">{propNameList ? getparams() : ""}</div> */}
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Component;
